/**
 * Kendrex Colony has no music or sound effects on the map or in its missions (41–46),
 * except mission 46 (Cello boss): tune_up, cello_main loop, and masterpiece deploy stingers only.
 */

let mapSuppressed = false;
let battleSuppressed = false;
let mission46CelloBattleActive = false;

/** @type {ReadonlySet<string>} */
const MISSION_46_CELLO_ALLOWED_SOUND_PATHS = new Set([
  '/sounds/tune_up.mp3',
  '/sounds/cello_main.mp3',
  '/sounds/cello1.mp3',
  '/sounds/cello2.mp3',
  '/sounds/cello3.mp3',
]);

/** @param {boolean} value */
export function setExploreUnknownKendrexColonyMapAudioSuppressed(value) {
  mapSuppressed = value === true;
}

/** @param {boolean} value */
export function setExploreUnknownKendrexColonyBattleAudioSuppressed(value) {
  battleSuppressed = value === true;
}

/** @param {boolean} value */
export function setExploreUnknownMission46CelloBattleActive(value) {
  mission46CelloBattleActive = value === true;
}

/**
 * @param {unknown} soundPath
 * @returns {boolean}
 */
export function isExploreUnknownMission46CelloAllowedSound(soundPath) {
  return typeof soundPath === 'string' && MISSION_46_CELLO_ALLOWED_SOUND_PATHS.has(soundPath);
}

/**
 * @param {unknown} [soundPath]
 * @returns {boolean}
 */
export function isExploreUnknownKendrexColonyAudioSuppressed(soundPath) {
  if (
    mission46CelloBattleActive &&
    typeof soundPath === 'string' &&
    isExploreUnknownMission46CelloAllowedSound(soundPath)
  ) {
    return false;
  }
  return mapSuppressed || battleSuppressed;
}
